'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogRegistrationIfNeeded = exports.getAllUserCatalogRegistrationIds = exports.isCatalogRegistrationLoading = exports.getLoadTimeForCatalogRegistration = exports.getCatalogRegistration = exports.LOAD_CATALOG_REGISTRATION_SUCCESS = exports.LOAD_CATALOG_REGISTRATION_REQUEST = exports.LOAD_CATALOG_REGISTRATION_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;

var _user = require('./user');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _liveBid = require('./liveBid');

var _config = require('./config');

var _console = require('./console');

var _login = require('./login');

var _passwordReset = require('./passwordReset');

var _registerForCatalog = require('./registerForCatalog');

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOG_REGISTRATION_FAIL = exports.LOAD_CATALOG_REGISTRATION_FAIL = 'la/domain/catalogRegistration/LOAD_FAIL';
var LOAD_CATALOG_REGISTRATION_REQUEST = exports.LOAD_CATALOG_REGISTRATION_REQUEST = 'la/domain/catalogRegistration/LOAD_REQUEST';
var LOAD_CATALOG_REGISTRATION_SUCCESS = exports.LOAD_CATALOG_REGISTRATION_SUCCESS = 'la/domain/catalogRegistration/LOAD_SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_CATALOG_REGISTRATION_FAIL:
            return (0, _extends5.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.catalogId])
            });
        case LOAD_CATALOG_REGISTRATION_REQUEST:
            return (0, _extends5.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case _registerForCatalog.REGISTER_FOR_CATALOG_SUCCESS:
            return (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, action.payload, {
                    approved: false,
                    catalogId: action.payload,
                    pending: true,
                    registered: false
                }))
            });
        case _user.LOAD_BIDDER_DATA_SUCCESS:
        case _login.LOGIN_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            time = action.meta.actionTime;
            loaded = (0, _extends5.default)({}, state.loaded);
            existing = (0, _cloneDeep2.default)(state.byId);
            if (action.payload.catalogRegistration) {
                action.payload.catalogRegistration.forEach(function (catalog) {
                    existing[catalog.catalogId] = catalog;
                    loaded[catalog.catalogId] = time;
                });
            }
            return (0, _extends5.default)({}, state, {
                byId: existing,
                loaded: loaded
            });

        case LOAD_CATALOG_REGISTRATION_SUCCESS:
            time = action.meta.actionTime;
            loaded = (0, _extends5.default)({}, state.loaded, (0, _defineProperty3.default)({}, action.meta.catalogId, time));
            loading = [].concat((0, _toConsumableArray3.default)(state.loading));
            loading = (0, _difference2.default)(loading, [action.meta.catalogId]);

            var existingCatalog = state.byId[action.meta.catalogId] || {};

            if (action.payload.approved && !existingCatalog.approved) {
                existing = (0, _cloneDeep2.default)(state.byId);
                existing[action.meta.catalogId] = existing[action.meta.catalogId] || {};
                existing[action.meta.catalogId].approved = true;
                existing[action.meta.catalogId].pending = false;
                existing[action.meta.catalogId].declined = false;
                return (0, _extends5.default)({}, state, {
                    byId: existing,
                    loaded: loaded,
                    loading: loading
                });
            } else if (!action.payload.approved && existingCatalog.approved) {
                existing = (0, _cloneDeep2.default)(state.byId);
                existing[action.meta.catalogId] = existing[action.meta.catalogId] || {};
                existing[action.meta.catalogId].approved = false;
                existing[action.meta.catalogId].pending = false;
                existing[action.meta.catalogId].declined = false;
                return (0, _extends5.default)({}, state, {
                    byId: existing,
                    loaded: loaded,
                    loading: loading
                });
            }

            return (0, _extends5.default)({}, state, {
                loaded: loaded,
                loading: loading
            });

        case _user.LOG_OUT_BIDDER:
            return (0, _extends5.default)({}, DEFAULT_STATE);

        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.catalogRegistration;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getCatalogRegistration = exports.getCatalogRegistration = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForCatalogRegistration = exports.getLoadTimeForCatalogRegistration = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isCatalogRegistrationLoading = exports.isCatalogRegistrationLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getAllUserCatalogRegistrationIds = exports.getAllUserCatalogRegistrationIds = function getAllUserCatalogRegistrationIds(state) {
    return (0, _keys2.default)(state.user.catalogRegistration.byId).map(function (catIdString) {
        return Number(catIdString);
    });
};

var fetchCatalogRegistration = function fetchCatalogRegistration(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, email, catalogData, source, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            _context.prev = 1;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            email = (0, _user.getBidderEmail)(state);
                            catalogData = (0, _console.getLiveCatalogData)(state, catalogId);
                            source = (0, _liveBid.getBidSource)(state);


                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: catalogId,
                                type: LOAD_CATALOG_REGISTRATION_REQUEST
                            });
                            _context.next = 10;
                            return _api.CatalogRegistration.fetchCatalogRegistration({ authToken: authToken, catalogId: catalogId, deployment: deployment, email: email, source: source });

                        case 10:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogId: catalogId },
                                payload: (0, _extends5.default)({}, response.data, { catalogId: catalogId, created: new Date().getTime(), wasApproved: catalogData.approved }),
                                type: LOAD_CATALOG_REGISTRATION_SUCCESS
                            });
                            _context.next = 17;
                            break;

                        case 14:
                            _context.prev = 14;
                            _context.t0 = _context['catch'](1);

                            dispatch({
                                error: true,
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: LOAD_CATALOG_REGISTRATION_FAIL
                            });

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[1, 14]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var shouldFetchCatalogRegistration = function shouldFetchCatalogRegistration(state, catalogId) {
    if (!catalogId) return false;
    var loading = isCatalogRegistrationLoading(state, catalogId);
    return !loading;
};

var fetchCatalogRegistrationIfNeeded = exports.fetchCatalogRegistrationIfNeeded = function fetchCatalogRegistrationIfNeeded(catalogId) {
    return function (dispatch, getState) {
        if (shouldFetchCatalogRegistration(getState(), catalogId)) {
            return dispatch(fetchCatalogRegistration(catalogId));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalogRegistration.js
// module id = uhYE
// module chunks = 60